import React, { useState } from 'react';
import { FlatList } from 'react-native';
import type { PlayerSquareProps, PublicPlayerProps, SquareOfferProps, SquareProps } from "../../types"
import { Icons } from '../../Components';
import SquareOfferCard from './SquareOfferCard';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type SquareOffersCardProps = {
    player_id?:string,
    players:PublicPlayerProps[],
    squares:SquareProps[],
    player_squares:PlayerSquareProps[],
    home_abbr?:string,
    away_abbr?:string,
    square_offers:SquareOfferProps[],
    onRequestAuthenticate:() => void
}
const SquareOffersCard = ({ square_offers, players, squares, player_squares, player_id, away_abbr, home_abbr, onRequestAuthenticate }:SquareOffersCardProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(true);

    const renderOffers = (data: { item:SquareOfferProps, index:number }) => {
        const player_square = player_squares.find(ps => ps.sq_player_square_id == data.item.sq_player_square_id);
        if(!player_square){ return <></> }
        const square = squares.find(s => s.sq_square_id == player_square.sq_square_id);
        if(!square){ return <></> }
        const offer_from = players.find(p => p.player_id == data.item.offerer_id);
        return (
            <View transparent style={{ margin:5 }}>
                <SquareOfferCard
                    square_offer={data.item}
                    square={square}
                    offer_owner={offer_from}
                    home_abbr={home_abbr}
                    away_abbr={away_abbr}
                    player_square={player_square}
                    player_id={player_id}
                    onRequestAuthenticate={onRequestAuthenticate}
                />
            </View>
        )
    }
    return (
        <View style={{ minWidth:350 }}>
            <Button transparent style={{ borderRadius:0, flexDirection:'row', alignItems:'center', backgroundColor:C.views.header }} onPress={() => setExpanded(!expanded)}>
                <View float style={{ marginRight:10, height:26, width:26, borderRadius:100, justifyContent:'center', alignItems:'center', backgroundColor:C.text.success }}>
                    <Text theme='h1' color={C.text.white}>{square_offers.length}</Text>
                </View>
                <View transparent style={{flex:1, marginRight:10}}>
                    <Text theme='h1'>SQUARE OFFERS</Text>
                    <Text style={{ marginTop:3 }} theme='description'>These are offers from you or other users to buy or sell squares during the game</Text>
                </View>
                <Icons.ChevronIcon direction={expanded?'up':'down'} size={8} color={C.text.h1} />
            </Button>
            {expanded ?
            <View transparent type='body' style={{ padding:10 }}>
                <FlatList
                    data={square_offers}
                    renderItem={renderOffers}
                    horizontal
                    keyExtractor={(item) => item.sq_offer_id.toString()}
                />
            </View>
            :<></>}
        </View>
    )
}

export default SquareOffersCard